import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownBlock, markdownBlocks } from './agent-markdown';

@Component({
  selector: 'app-agent-markdown', standalone: true, imports: [CommonModule],
  templateUrl: './agent-markdown.component.html', styleUrls: ['./agent-markdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentMarkdownComponent {
  blocks: MarkdownBlock[] = [];
  private previous = '';
  @Input() set content(value: string | null | undefined) {
    const text = value || '';
    if (text !== this.previous) { this.previous = text; this.blocks = markdownBlocks(text); }
  }
}
